//src/pages/REG/REG100F1.jsx
import React, {useContext, useEffect, useRef, useState} from 'react';
import style from "./REG100F1.module.scss";
import toast from "components/Toast/Toast";
import Button from "components/Button/Button";
import SwitchGroup from "components/Button/SwitchGroup"
import InputUnitText from "components/InputText/InputUnitText";
import Table from "components/Table/Table";
import DatePicker from "components/DatePicker/DatePicker";
import {dateToYMD, ymdToDate} from './REGComUtil'; //
import {postData} from 'utils/TransactionUtil';
import {AuthContext} from "contexts/AuthContext";
import styleCom from "./REGCOM.module.scss";
import SelectBox from "../../components/SelectBox/SelectBox";


// 페이지 시작
const REG100F1 = ({navBar: NavBar}) => {


    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기

    const [comHsptObj, setComHsptObj] = useState([]);
    const [hsptObj, setHsptObj] = useState([]);


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [res, setRes] = useState({});
    const [param, setParam] = useState({});

    const refs = useRef([]);
    const initObj = [
        {name:"hsptCd", label: "등록기관", value: userInfo.hsptCd},
        {name:"hsptNm", label: "등록기관명", value: "."},
        {name:"initial", label: "대상자 영문 이니셜", value: ""},
        {name:"acquisitionDt", label: "동의서 취득일", value: ""},
        {name:"pciDt", label: "PCI 시행일", value: ""},
        {name:"age", label: "연령(만)", value: ""},
        {name:"sex", label: "성별", value: ""},
        // {name:"cmt", label: "비고", value: ""},
        {name:"subjectAgreeDt", label: "대상자 서면 동의일", value: ""},
        {name:"validYn", label: "적합 대상자 확인 여부", value: ""},
        {name:"include1Yn", label: "선정기준1", value: ""},
        {name:"include2Yn", label: "선정기준2", value: ""},
        {name:"include3Yn", label: "선정기준3", value: ""},
        {name:"exclude1Yn", label: "제외기준1", value: ""},
        {name:"exclude2Yn", label: "제외기준2", value: ""},
        {name:"exclude3Yn", label: "제외기준3", value: ""},
        {name:"exclude4Yn", label: "제외기준4", value: ""},
        {name:"exclude5Yn", label: "제외기준5", value: ""},
        {name:"exclude6Yn", label: "제외기준6", value: ""},
        {name:"exclude7Yn", label: "제외기준7", value: ""},
        {name:"exclude8Yn", label: "제외기준8", value: ""},
        {name:"exclude9Yn", label: "제외기준9", value: ""}
    ];

    const [inputFild, setInputFild] = useState(initObj);
    const [inputData, setInputData]  = useState(inputFild);
    const [isCheckCriteria, setIsCheckCriteria] = useState(false);

    useEffect(() => {
        //공통코드 호출
        getComDtlsCd("HSPT_CD");

    }, []);



    useEffect(() => {
        const requiredNames = [ "include1Yn", "include2Yn", "include3Yn"
                                     ,"exclude1Yn", "exclude2Yn", "exclude3Yn" , "exclude4Yn", "exclude5Yn"
                                     ,"exclude6Yn", "exclude7Yn", "exclude8Yn" ,"exclude9Yn"];
        const allExistAndHaveValue = requiredNames.every(name => {
            const field = inputData.find(f => f.name === name);
            return field && field.value != null && field.value !== '' && !(typeof field.value === 'string' && field.value.trim() === '');
        });

        if(allExistAndHaveValue){
            setIsCheckCriteria(false);
        }else{
            setIsCheckCriteria(true);
        }

    }, [inputData]);


    //확인 버튼 클릭
    const onClickSave = (e) => {
        const getParam = Object.fromEntries(inputData.map(field => [field.name, field.value]));
        setParam(getParam);

        if(validate()){
            const getParam = Object.fromEntries(inputData.map(field => [field.name, field.value]));
            setParam(getParam);
            callAddNewCase(getParam).then(() => {
                setInputData(inputFild);
                toast({type: 'info', message: "저장이 완료되었습니다.", opt: {position: "top-center"}});

            });

        }
    }

    //데이터 셋팅 및 유효성 검사
    const validate = () => {
        let valid = false;
        const hasEmptyString = inputData.some(item => item.value === '');
        if(hasEmptyString){
            valid = false;
            toast({type: 'warning', message: "미입력 항목을 확인하여 주십시오."});
        }else{
            valid = true;

        }

        return  valid;
    };

    //데이터 Setter
    const setItemValue = (name, value) => {
        setInputData(prevData =>
            prevData.map(item =>
                item.name === name && item.value !== value ? { ...item, value } : item
            )
        );
    };

    const getItemValue = (getName) =>{
        return inputData.find(item => item.name === getName).value;
    }

    const getItemLabel = (getName) =>{
        return inputData.find(item => item.name === getName).label;
    }

    const handleChange_upper = (name, value) =>{
        const input = value;
        const onlyUppercase = input.replace(/[^A-Z]/g, '');
        setItemValue(name, onlyUppercase);
    }

    const handleChange_acquisitionDt = (dateYmd) =>{
        setItemValue('acquisitionDt', dateYmd);  // 동의서 취득일
        setItemValue('subjectAgreeDt', dateYmd); // 대상자 서면 동의일
    }


    const btnClickInclusionYes = () => {
        setItemValue("include1Yn", 'Y');
        setItemValue("include2Yn", 'Y');
        setItemValue("include3Yn", 'Y');
    };
    const btnClickExclusionNo = () => {
        setItemValue("exclude1Yn", 'N');
        setItemValue("exclude2Yn", 'N');
        setItemValue("exclude3Yn", 'N');
        setItemValue("exclude4Yn", 'N');
        setItemValue("exclude5Yn", 'N');
        setItemValue("exclude6Yn", 'N');
        setItemValue("exclude7Yn", 'N');
        setItemValue("exclude8Yn", 'N');
        setItemValue("exclude9Yn", 'N');
    };



///////////////////////////////
    /* Call Service====================================================================================================*/
    async function getComDtlsCd(grpCd) {
        const param = {comGrpCd:grpCd}
        const resultHsptData = await postData("/getComDtlsCd", param);
        setComHsptObj(resultHsptData);
        const hsptArray = resultHsptData.map(item => ({
                value: item.comnDtlsCd,
                label: item.detlCdNm
            }));
        setHsptObj(hsptArray);
    }

    async function callAddNewCase(getParam, setRes, setIsModalOpen) {
        let result = await postData("/RED/addNewCase", getParam);
        let resData = {

        }
    }




    return (
        <>
        <NavBar>
            {/*공통 영역*/}
            <div className={style.search_wrap}>
                <Button variant="Primary" size="md" addStyle={{width: "58px", height: "40px"}}
                        onClick={onClickSave}>
                    저장
                </Button>
            </div>
        </NavBar>

            {/*메인 영역*/}
            <div className={styleCom.root_wrap} style={{height: "750px", overflowY: "scroll"}}>
                <div className={styleCom.title_wrap} style={{marginTop: "10px", marginBottom: '-20px'}}>
                    <h3>NEW CASE</h3>
                </div>
                <div className={styleCom.main_wrap}>
                    <Table variant='default' rowCnt={3} colSize={['25%', '25%', '25%', '25%']} rowSize={'56px'}>
                        <div>{getItemLabel('hsptNm')}</div>
                        <div>
                            <SelectBox options={hsptObj} value={getItemValue("hsptCd")}
                                       valueKey="comnDtlsCd" labelKey="detlCdNm"
                                       onChange={(value) => ''}
                                       isDisabled={true} width={"90%"}/>
                        </div>
                        <div>{getItemLabel('initial')}</div>
                        <div>
                            <InputUnitText type={"text"} value={getItemValue('initial')} unit={""}
                                           //onChange={(value) => setItemValue( 'initial', value)}/>
                                           onChange={(value) => handleChange_upper( 'initial', value.toUpperCase())}/>


                        </div>
                        <div>{getItemLabel('acquisitionDt')}</div>
                        <div>
                            <DatePicker selDate={ymdToDate(getItemValue('acquisitionDt'))}
                                        dateFormat={'yyyy-MM-dd'}
                                        onChange={(date) => handleChange_acquisitionDt(dateToYMD(date))}/>

                        </div>
                        <div>{getItemLabel('pciDt')}</div>
                        <div>
                            <DatePicker selDate={ymdToDate(getItemValue('pciDt'))}
                                        dateFormat={'yyyy-MM-dd'}
                                        onChange={(date) => setItemValue('pciDt', dateToYMD(date))}/>
                        </div>
                        <div>{getItemLabel("age")}</div>
                        <div>
                            <InputUnitText type={"number"} value={getItemValue("age")} unit={"세"}
                                           onChange={(value) => setItemValue("age", value)}/>
                        </div>
                        <div>{getItemLabel('sex')}</div>
                        <div>
                            <SwitchGroup value={getItemValue("sex")}
                                         onClick={(value) => setItemValue("sex", value)}
                                         items={{"남성": "M", "여성": "F"}}
                            />
                        </div>
                        {/*<div>{getItemLabel("cmt")}</div>*/}
                        {/*<div className="col_merge">*/}
                        {/*    <InputUnitText value={getItemValue("cmt")} type={"string"} unit={""}*/}
                        {/*                   onChange={(value) => setItemValue("cmt", value)}/>*/}
                        {/*</div>*/}
                    </Table>

                    <Table variant='default' rowCnt={1} colSize={['25%', '75%']} rowSize={'56px'}>
                        <div>{getItemLabel('subjectAgreeDt')}</div>
                        <div>
                            <DatePicker selDate={ymdToDate(getItemValue('subjectAgreeDt'))}
                                        dateFormat={'yyyy-MM-dd'}
                                        onChange={(date) => setItemValue('subjectAgreeDt', dateToYMD(date))}/>
                        </div>
                    </Table>

                    <h3>선정/제외 기준평가</h3>
                    <Table variant='Vertical' rowCnt={15} colSize={['75%', '25%']} rowSize={'56px'}>
                        <div className={style.cellTyp1}>상기 시험 대상자는 선정/제외 기준을 만족하고, 관찰연구 참여에 적합합니까?
                            (선정/제외 기준을 모두 확인한 후 선택 가능합니다)
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("validYn")}
                                         onClick={(value) => setItemValue("validYn", value)}
                                         items={{"YES": "Y", "NO": "N"}} isDisabled={isCheckCriteria}
                            />
                        </div>
                        <div className={"col_merge"} style={{justifyContent: 'left', backgroundColor: "#FAFAFA"}}>
                            <span className={style.cellHeader} style={{marginRight: "10px"}}>Inclusion Criteria</span>
                            <Button variant="Secondary" addStyle={{width: "80px", height: "38px"}}
                                    onClick={() => btnClickInclusionYes()}>All Yes</Button>
                        </div>

                        <div className={style.cellTyp1}>1. 만 19 세 이상의 성인</div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("include1Yn")}
                                         onClick={(value) => setItemValue("include1Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>2. 최근 1개월 내에 관상동맥질환(모든 종류의 협심증, 심근경색)으로 확인된 병변에
                            EluNIR 스텐트(EluNIR™, EluNIR-PERL™)를 사용하여 관상동맥중재술을 받은 환자
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("include2Yn")}
                                         onClick={(value) => setItemValue("include2Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>3. 본 연구에 자발적으로 참여를 결정하고 서면 동의한 자</div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("include3Yn")}
                                         onClick={(value) => setItemValue("include3Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={"col_merge"} style={{justifyContent: 'left', backgroundColor: "#FAFAFA"}}>
                            <span className={style.cellHeader} style={{marginRight: "10px"}}>Exclusion Criteria</span>
                            <Button variant="Secondary" addStyle={{width: "80px", height: "38px"}}
                                    onClick={() => btnClickExclusionNo()}>All No</Button>
                        </div>
                        <div className={style.cellTyp1}>
                            1. 다음의 약물이나 물질에 대해 알려진 과민증이나 금기가 있는 환자: 헤파린, 아스
                            피린, 클로피도그렐, 리다포롤리무스, 코발트 크롬, 스테인리스스틸, 니켈, 316L
                            금속 및 조영제(단, 조영제에 대한 과민성이 있는 연구대상자라도 스테로이드와 페 니라민에 의해 조절될 수 있는 경우에는 등록이 가능하나, 알려진 아나필락시스가 있는
                            경우
                            제외 대상이다.)
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude1Yn")}
                                         onClick={(value) => setItemValue("exclude1Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>
                            2. 출혈 경향이나 혈액 응고 장애의 병력이 있는 경우
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude2Yn")}
                                         onClick={(value) => setItemValue("exclude2Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>
                            3. 임산부, 수유부 또는 가임기 여성 중 본 연구기간 동안 임신을 계획하고 있는 자
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude3Yn")}
                                         onClick={(value) => setItemValue("exclude3Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>
                            4. 내원시 심인성 쇽(cardiogenic shock)을 동반한 경우
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude4Yn")}
                                         onClick={(value) => setItemValue("exclude4Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>
                            5. 예상 기대수명이 1년 미만인 자
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude5Yn")}
                                         onClick={(value) => setItemValue("exclude5Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>
                            6. 좌심실구혈률(LVEF, left ventricular ejection fraction)이 30% 이하인 경우
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude6Yn")}
                                         onClick={(value) => setItemValue("exclude6Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>
                            7. 등록시 EluNIR 스텐트 외 다른 스텐트를 사용하여 시술 받은 환자
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude7Yn")}
                                         onClick={(value) => setItemValue("exclude7Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>
                            8. 의료기기 무작위 배정 연구에 참여 중인 대상자
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude8Yn")}
                                         onClick={(value) => setItemValue("exclude8Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>
                        <div className={style.cellTyp1}>
                            9. 연구자가 본 연구 참여에 부적합하다고 판단한 경우
                        </div>
                        <div className={style.cellTyp2}>
                            <SwitchGroup value={getItemValue("exclude9Yn")}
                                         onClick={(value) => setItemValue("exclude9Yn", value)}
                                         items={{"YES": "Y", "NO": "N"}}
                            />
                        </div>


                    </Table>
                </div>

            </div>

            {/*<Modal*/}
            {/*    open={isModalOpen}*/}
            {/*    handle_Close={() => setIsModalOpen(false)}*/}
            {/*    title="입력정보"*/}
            {/*    width="1220px"*/}
            {/*    height="900px"*/}
            {/*    isHeader={true}*/}
            {/*    isBottom={false}>*/}
            {/*    <ConfirmModal param={param} res={res}/>*/}
            {/*</Modal>*/}

        </>
    );
};


export default REG100F1;
